import gql from 'graphql-tag';
import { apolloClient } from '../apolloClient.js';

let currentUserPromise;
export const GET_CURRENT_USER = gql`
  {
    currentUser {
      id
      firstName
      lastName
      userName
      email
      phoneNumber
      webUserId
      agentId
      organizationId
      ipAuthenticatedUser
      enabledFeatures
      homepage
      salesRegion
      firstLoginDate
      lastLoginDate
      isInternal
      accessibleApps
      external {
        hasBrmData
        primaryRelationshipManager {
          name
          firstName
          lastName
          retired
          email
          jobTitle
          phone
        }
        secondaryRelationshipManager {
          name
          firstName
          lastName
          retired
          email
          jobTitle
          phone
        }
        agreementOwner {
          name
          firstName
          lastName
          retired
          email
          jobTitle
          phone
        }
      }
    }
    getUserHomePages
  }
`;

export function getCurrentUser() {
  return currentUserPromise;
}

export function refetchCurrentUser() {
  return (currentUserPromise = apolloClient
    .query({ query: GET_CURRENT_USER })
    .then((res) => {
      const { webUserId, organizationId, agentId } = res.data.currentUser;
      const userAvailableHomePages = res.data.getUserHomePages;
      sessionStorage.setItem('userId', webUserId);
      sessionStorage.setItem('orgId', organizationId);
      sessionStorage.setItem('agntId', agentId);
      // add user available home pages key into current user data
      return { ...res.data.currentUser, userAvailableHomePages };
    })
    .catch(() => {
      throw new Error('User API returned unsuccessful');
    }));
}
